module.exports = __webpack_public_path__ + "img/tu03.796e5710.png";